import Footer from "../Footer";
import NavbarTop from "../NavbarTop";
import MenuInicioRapido from "../MenuInicioRapido";
import React, { useEffect, useState } from "react";
import MenuMinhaConta from "../MenuMinhaConta";
import PesquisaArtigo from "../PesquisaArtigo";

export default function Login() {
  const [showScrollButton, setShowScrollButton] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const checkScrollTop = () => {
      if (!showScrollButton && window.pageYOffset > 400) {
        setShowScrollButton(true);
      } else if (showScrollButton && window.pageYOffset <= 400) {
        setShowScrollButton(false);
      }
    };

    window.addEventListener("scroll", checkScrollTop);

    return () => {
      window.removeEventListener("scroll", checkScrollTop);
    };
  }, [showScrollButton]);

  useEffect(() => {
    // Rola a página para o topo sempre que a página é carregada
    window.scrollTo(0, 0);
  }, []); // Executa o efeito apenas uma vez, quando o componente é montado

  return (
    <>
      <section>
        <div>
          <NavbarTop />
        </div>

        <div className="container col-md-11">
          <div className="row content section paddingt-2 white-background">
            <div className="col-md-12">
              <nav aria-label="breadcrumb" role="navigation">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item">
                    <a href="/minha-conta-e-login">Minha Conta e Login</a>
                  </li>
                  <li className="breadcrumb-item active">Como fazer login?</li>
                </ol>
              </nav>
            </div>
          </div>

          <div className="row justify-content-between">
            <div className="col-md-3 text-left d-none d-md-inline-block">
              <MenuMinhaConta />
            </div>

            <div className="col-md-6">
              <h1 className="article-heading">Como fazer login?</h1>
              <hr />

              <div className="row justify-content-between" id="article-meta">
                <div className="author col-6 pl-5">
                  <span className="author-name">Minha Conta e Login</span>
                </div>
                <small className="col-6 text-right pr-5">
                  Informações de acesso
                </small>
              </div>
              <hr />

              <div className="content article-content">
                <br></br>

                <p>
                  Clique em "Login" no canto superior direito do site ou{" "}
                  <a> </a>
                  <a href="https://salesbox.com.br/identity/" target="blank">
                    clique aqui
                  </a>{" "}
                  para acessar a plataforma.
                </p>

                <figure>
                  <img
                    src="img/login-sales-box.png"
                    alt="excel"
                    style={{ display: "block", margin: "0 auto" }}
                  />
                </figure>

                <figcaption>Login: Site</figcaption>

                <p>
                  Em seguida, preencha seus dados de acesso e clique em
                  "Entrar".
                </p>

                <figure>
                  <img
                    src="img/pagina-login-plataforma.png"
                    alt="excel"
                    style={{ display: "block", margin: "0 auto" }}
                  />
                </figure>

                <figcaption>Login: Plataforma</figcaption>

                <p>
                  Caso tenha esquecido sua senha, acesse o artigo <a> </a>
                  <a href="/esqueci-minha-senha-o-que-fazer" target="blank">
                    Esqueci minha senha, o que fazer?
                  </a>
                </p>

                <br></br>
              </div>

              {/* Seção de votos */}

              <div>
                <PesquisaArtigo />
              </div>
            </div>

            <div className="col-md-3 text-left d-none d-md-inline-block">
              <MenuInicioRapido />
            </div>
          </div>
        </div>
      </section>

      {showScrollButton && (
        <a onClick={scrollToTop} className="btn-topo">
          <a style={{ fontSize: "25px" }}>↑</a> Voltar ao Topo
        </a>
      )}

      <Footer />
    </>
  );
}
